import {simpleState} from 'root/shared/tools/router-helper';
import * as ErrorPage from './error/error.ctrl';
import * as SuccessPage from './success/success.ctrl';

export default States;

States.$inject = ['$stateProvider', '$urlRouterProvider'];
function States($stateProvider, $urlRouterProvider) {

  $stateProvider
    .state('error', simpleState('/error?id', ErrorPage.HTML, ErrorPage.Controller, [], { resolve: { errorId: getIdFromStateParam }}))
    .state('success', simpleState('/success?id&data', SuccessPage.HTML, SuccessPage.Controller))
  ;

  $urlRouterProvider.otherwise('/');
}

getIdFromStateParam.$inject = ['$stateParams'];
function getIdFromStateParam($stateParams){
  return $stateParams.id || '404';
}
